<template>
    <div class="orderDetail">
        <el-row>
            <el-card class="box-card">
                  <div class="text item">
                    <el-descriptions class="margin-top" :column="1" size="medium" border :labelStyle="labelStyle" :contentStyle="contentStyle">
                  <el-descriptions-item label-class-name="my-label" >
                    <template slot="label">
                      工单号
                    </template>
                    {{ orderDta.sn }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      工单类型
                    </template>
                    {{ orderDta.type }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      标题
                    </template>
                    {{ orderDta.title }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      提交时间
                    </template>
                    {{ orderDta.create_time }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      工单状态
                    </template>
                    <el-tag size="small">{{ orderDta.status }}</el-tag>
                    <el-tag size="medium" v-if="orderDta.status == '已受理'">{{ orderDta.accept_person }}</el-tag>
                    <el-tag size="medium" v-if="orderDta.status == '已退回'">{{ orderDta.changeback_person }}</el-tag>
                    <el-tag size="medium" v-if="orderDta.status == '已归档'">{{ orderDta.placeonfile_person }}</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      产品型号
                    </template>
                    {{ orderDta.goods_model }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      所属部门
                    </template>
                    {{ orderDta.goods_category_name }}
                  </el-descriptions-item>
            </el-descriptions>
                  </div>
            </el-card>
        </el-row>

        <el-row class="replyTable">
            <el-card>
              <div slot="header" class="clearfix">
              <span>沟通记录</span>
            </div>
            <div class="content">
              <div class="firstContent">
                  <div class="firstname">{{ orderDta.publish_person }}</div>
                  <div class="firstcontent" v-html="orderDta.detail.replace(/\n|\r\n/g, '<br>').replace(/ /g, ' &nbsp')"></div>
                  <div class="filContent">
                      <div class="imag" v-for="(item,index) in firstImgList" :key="index">
                        <el-image
                        style="width: 60px;height: 60px;"
                        v-if="item == urlHerf?false:true"
                        :src="item"
                        fit="fill"
                        @click="previewImageEvent(item,firstImgList)"
                        ></el-image>
                      </div>
                      <div class="fileMain">
                          <a v-for="val in firstFileList" :key="val.id" @click="downLoadFile(val)">
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='txt'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/txt.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='pdf'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/pdf.png')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='pptx' || val.url.split('.')[val.url.split('.').length-1]=='ppt'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/ppt.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='xlsx' || val.url.split('.')[val.url.split('.').length-1]=='xls'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/excel.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='doc' || val.url.split('.')[val.url.split('.').length-1]=='docx'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/word.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='avi'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/avi.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='rar' || val.url.split('.')[val.url.split('.').length-1]=='7z'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/zip.png')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                          </a>
                          <a v-for="val in firstFileList" :key="val.url" @click="watchEvent(val)">
                            <div class="fileList" v-if="val.url.split('.')[val.url.split('.').length-1]=='mp4' || val.url.split('.')[val.url.split('.').length-1]=='webm' || val.url.split('.')[val.url.split('.').length-1]=='ogg' || val.url.split('.')[val.url.split('.').length-1]=='mov'">
                                <div class="imageFile">
                                  <el-image :src = "require('../../assets/filetype/video.jpg')">
                                  </el-image>
                                </div>
                                <div class="bootomName">
                                    {{ val.name }}
                                </div>
                            </div>
                          </a>
                      </div>
                  </div>
              </div>
              <div class="mains" v-for="item in replyTable" :key="item.content">
                  <div class="title">
                    <div class="name">{{ item.reply_person }}</div>
                    <div class="time">{{  item.create_time  }}</div>
                  </div>
                  <div class="atmain">
                      <span class="atItem" v-for="val in item.atPerson" :key="val">@{{ val }}</span>
                  </div>
                  <div class="reply_content" v-if="item.quote_reply_content !== ''"><div>{{ item.quote_reply.reply_person }} : {{ item.quote_reply_content }}</div></div>
                  <div class="file">
                      <!-- <div class="qs">{{  item.content  }}</div> -->
                      <div class="qs"  v-html="item.content.replace(/\n|\r\n/g, '<br>').replace(/ /g, ' &nbsp')"></div>
                      <div class="impor"><el-button type="text" @click="quote(item)">引用</el-button></div>
                  </div>
                  <div class="fileMains">
                    <div class="imgas" v-for="itemChildren in item.imgList" :key="itemChildren.index">
                      <el-image
                      style="width: 60px;height: 60px;"
                      v-if="itemChildren == urlHerf?false:true"
                        :src="itemChildren"
                        fit="fill"
                        @click="previewImageEvent(itemChildren,item.imgList)"
                        ></el-image>
                    </div>
                <!-- 文件列表 -->
                    <div v-if="item.attach_file_info.length!==0" class="fileContents">
                          <a v-for="val in item.attach_file_info" :key="val.id" @click="downLoadFile(val)">
                            <!-- {{ val }} -->
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='txt'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/txt.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='pdf'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/pdf.png')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='ppt' || val.url.split('.')[val.url.split('.').length-1]=='pptx'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/ppt.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='xlsx' || val.url.split('.')[val.url.split('.').length-1]=='xls'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/excel.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='doc' || val.url.split('.')[val.url.split('.').length-1]=='docx'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/word.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='avi'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/avi.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='rar' || val.url.split('.')[val.url.split('.').length-1]=='7z'">
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/zip.png')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                          </a>
                          <a v-for="val in item.attach_file_info" :key="val.url" @click="watchEvent(val)">
                            <div class="fileListss"  v-if="val.url.split('.')[val.url.split('.').length-1]=='mp4' || val.url.split('.')[val.url.split('.').length-1]=='webm' || val.url.split('.')[val.url.split('.').length-1]=='ogg' || val.url.split('.')[val.url.split('.').length-1]=='mov'" >
                              <div class="fileTop">
                                <el-image :src = "require('../../assets/filetype/video.jpg')">
                                </el-image>
                              </div>
                              <div class="names">{{ val.name }}</div>
                            </div>
                          </a>
                    </div>
                  </div>
              </div>
              <div class="mainplaceon" v-if="isMainplaceon"  v-for="item in orderDta.action_log" :key="item.id">
                <div v-if="item.action == '归档完结' || item.action == '不归档完结' || item.action == '退回'">
                  <div class="superTitle">超级管理员</div>
                  <div class="content">{{ item.remark }}</div>
                </div>
              </div>
            </div>
            </el-card>
        </el-row>

        <el-row class="reply">
          <el-card>
            <div slot="header" class="clearfix">
              <span>回复</span>
            </div>
            <el-form v-model="replyData" label-position="top" ref="replyData" >
              <el-form-item v-if="iconShow">
                <el-input v-model="replyData.quote" disabled></el-input>
                <i class="el-icon-circle-close" style="font-size: 20px;margin-left: 5px;line-height: 100%;cursor: pointer;" @click="iconClick"></i>
              </el-form-item>

              <el-form-item>
                <el-tag
                  v-for="(tag,index) in dingPeople"
                  :key="tag.name"
                  closable 
                  @close="dagClose(tag,index)">
                  {{tag.name}}
                </el-tag>
              </el-form-item>

               <el-form-item class="textarae">
                  <el-input class="el_input" type="textarea" v-model="replyData.content" @input="replyChange"></el-input>
               </el-form-item>
               <el-form-item class="uploadImg" prop="uploadImg" label="上传图片:">
                    <el-upload
                      :action="action"
                      header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                      list-type="picture-card"
                      :auto-upload="true"
                      :file-list="filsList"
                      :limit="9"
                      multiple
                      :before-upload="beforeAvatarUpload"
                      :on-change="imgHandleChange"
                      :on-success="imgSuccess"
                      :on-remove="imgRemove"
                      ref="pictureUpload"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                          <img
                            class="el-upload-list__item-thumbnail"
                            :src="file.url" alt=""
                          >
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="handlePictureCardPreview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>
                            <span
                              v-if="!disabled"
                              class="el-upload-list__item-delete"
                              @click="imgHandleRemove(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
              </el-form-item>
              <el-form-item prop="uploadFile" label="视频/文件:">
                    <el-upload
                      ref="dmtUploadFile"
                      class="upload-demo"
                      :action="action"
                      header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                      :auto-upload="true"
                      :on-preview="fileHandlePreview"
                      :on-remove="fileHandleRemove"
                      
                      :limit="3"
                      :before-upload="beforeFileUpload"
                      :on-exceed="fileHandleExceed"
                      :on-change="fileHandleChange"
                      :on-success="fileSuccess"
                      accept="doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi"
                      :file-list="fileList2">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi,mov文件，且不超过7M</div>
                    </el-upload>
              </el-form-item>
              <el-form-item class="btn">
                <el-button  type="primary" @click="replyOrder" style="margin-right: 5px;">回复</el-button>
                <el-popconfirm
                    v-if="isCanClose"
                    confirm-button-text='是'
                    cancel-button-text='否'
                    @confirm="orderArchiving"
                    icon="el-icon-info"
                    icon-color="red"
                    title="该操作会结束工单受理状态并且不可撤销，是否继续？"
                  >
                    <el-button slot="reference">问题已解决</el-button>
                </el-popconfirm>
                <el-button v-if="isCanBack" @click="isBackDialogShow = true">退回</el-button>
                <el-button v-if="isCanAccept"  @click="isAcceptDialogShow = true">受理工单</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>

        <!-- 待归档 -->
        <el-row class="tobeArchived" v-if="isCanPOF">
          <el-card>
              <span>该问题已完结是否问题归档?</span>
              <el-button type="primary" size="small" @click="archived">归档</el-button>
              <el-button type="default" size="small" @click="orderCloseClick">不归档</el-button>
          </el-card>
        </el-row>

        <el-dialog
          :title="videoTitle"
          :visible.sync="videVisible"
          width="100%">
          <video v-if="videVisible" width="100%"  controls="controls" autoplay="autoplay"
            :playsinline="true"
            :webkit-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-player-type="h5-page"
            x5-video-player-fullscreen="true">
              <source :src="videoSrc" type="video/mp4">
              <source :src="videoSrc" type="video/ogg">
              <source :src="videoSrc" type="video/webm">
          </video>
        </el-dialog>

        <el-dialog
          title="请输入的原因并点击“确定退回”退回该工单"
          :visible.sync="isBackDialogShow"
          width="70%">
          <el-input v-model="backRemark"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isBackDialogShow = false">再想想</el-button>
            <el-button type="primary" @click="backClick">确定退回</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="工单受理提示"
          :visible.sync="isAcceptDialogShow"
          width="70%">
          <span>当前工单未受理，是否受理？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isAcceptDialogShow = false">不受理</el-button>
            <el-button type="primary" @click="confirmAccept">受理</el-button>
          </span>
        </el-dialog>

        <!-- <el-row>
          <button type="primary">检验钉钉API</button>
        </el-row> -->

    </div>
</template>

<script>

import { getOrderDetail,getReplyTable,orderReply,orderClose,sendMessage,removeAttach,setReaded,orderFinish,orderBack,getOrderAccept } from '../../utils/api'
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载

export default {
  components: {},
  props: {},
  data() {
    return {
      order_id:'',
      iconShow:false,
      isMainplaceon:false,
      videoSrc:'',
      videVisible:false,
      videoTitle:'',
      filsList:[],
      fileList2:[],
      imgList:[],
      dialogImageUrl:'',
      dialogVisible: false,
      disabled: false,
      action:localStorage.getItem('uploadUrl')+localStorage.getItem('user_token'),
      orderDta:{
        sn:'',
        type:'',
        title:'',
        create_time:'',
        status:'',
        detail:''
      },
      replyData:{
        quote:'',
        content:'',
        attach_image:'',
        attach_file:'',
        quote_reply_id:'',
      },
      replyTable:[],
      labelStyle:{
        width:'150px',
        background:'#fff',
        color:'#333'
      },
      contentStyle:{
        color:'#999'
      },
      firstImgList:[],
      firstFileList:[],
      dingPeople:[], //公司选择人,
      dingPeopleNmae:[],
      userid_list:[],
      urlHerf:localStorage.getItem('urlHerf'),
      worker:'',
      backRemark:"",
      isPublisher:false,
      isAccepter:false,
      isAccepted:false,
      isCanAccept:false,
      isCanBack:false,
      isCanClose:false,
      isCanPOF:false,
      isAcceptDialogShow:false,
      isBackDialogShow:false
    };
  },
  watch: {},
  computed: {},
  methods: {

    initOrderDetailStatus(){
        let that = this;
        that.orderDta.create_time = that.getTimeship(that.orderDta.create_time)
        if (that.orderDta.status == 1) {
          that.orderDta.status = '未受理'
        } else if (that.orderDta.status == 2) {
          that.orderDta.status = '已受理'
        } else if (that.orderDta.status == 3) {
          that.orderDta.status = '已退回'
        } else if (that.orderDta.status == 5) {
          that.orderDta.status = '待归档'
        }else if(that.orderDta.status == 6){
          that.orderDta.status = '已完结'
        }
    },

    initOrderDetailSwitch(){
        let that                  = this;
        that.isPublisher          = false;
        that.isAccepter           = false;
        that.isAccepted           = false;
        that.isCanAccept          = false;
        that.isCanBack            = false;
        that.isCanClose           = false;
        that.isCanPOF             = false;
        that.isAcceptDialogShow   = false;
        that.isBackDialogShow     = false;

        //是否为发布人
        if(that.worker.unionid == that.orderDta.publish_person_unionid){
          that.isPublisher = true;
        }

        //是否为受理人
        if(that.worker.unionid == that.orderDta.accept_person_unionid){
          that.isAccepter = true;
        }

        if(that.isPublisher != true && (that.orderDta.status == '未受理' || that.orderDta.status == '已受理') ){
          that.isCanBack = true;
        }

        if(that.isPublisher != true && that.orderDta.status == '未受理'){
          that.isCanAccept = true;
          that.isAcceptDialogShow = true;
        }

        if(that.isPublisher == true && that.orderDta.status == '已受理'){
          that.isCanClose = true;
        }

        if(that.orderDta.status == '已受理'){
          that.isAccepted = true;
        }

        if(that.orderDta.status == '待归档' && that.isAccepter){
          that.isCanPOF = true;
        }

    },

    initOrderDetailAttach(){
        let that = this;
        var imgList = []
        var arr = []
        imgList = that.orderDta.attach_image.split(',');
        imgList.forEach(item=>{
          item = that.urlHerf + item
          arr.push(item)
        })
        that.firstImgList = arr

        //文件
        var fileArr = that.orderDta.attach_file_info.length == 0?[]:that.orderDta.attach_file_info
        fileArr.forEach(item=>{
          item.url = that.urlHerf + item.url
        })
        that.firstFileList = fileArr

    },

    // 获取详情信息
    async getDetail(){
      var that = this
      return getOrderDetail({order_id : that.order_id})
      .then(res=>{
        if(res.message.status != 'success'){
            that.$message.error(res.message.text);
            that.orderDta = {};
            return;
          }

          that.orderDta = res.data;
          that.initOrderDetailStatus();
          that.initOrderDetailSwitch();
          that.initOrderDetailAttach();
      })
      .catch(err=>{
        that.$message.error(err);
      })
    },
    //获取沟通记录
    getReTable(){
      var that = this
      var param = {
        order_id:that.order_id,
        pagesize:0
      }
      getReplyTable(param)
      .then(res=>{
        console.log(res,'沟通记录');
        if(res.message.status == 'success'){
            that.replyTable = res.data
            that.replyTable.forEach(item=>{
              var imgList = []
              var arr = []
              item.create_time = that.getTimeship(item.create_time)
              //图片
              imgList = item.attach_image.split(',')
              imgList.forEach(ele=>{
                  ele =  that.urlHerf +  ele
                  arr.push(ele)
               })
               item['imgList'] = arr

              var fileList = item.attach_file_info.length == 0?[]:item.attach_file_info
              console.log(fileList,'fileList');
              // var arr1 = []
              fileList.forEach(ele=>{
                ele.url = that.urlHerf + ele.url
              })
              console.log(item,'item');
              item['atPerson'] = item.at_person_name.length == 0?[]:item.at_person_name.split(',')
            })
            console.log(that.replyTable,'that.replyTable');
        }else{
          that.replyTable = []
        }
      })
      .catch(err=>{
        console.log(err,'沟通记录err');
      })
    },
    // 下载文件列表
    downLoadFile(val){
      let link = document.createElement("a")
      link.style.display = "none"
      link.href = val.url
      var arr = val.url.split("/")
      link.setAttribute("download",arr[arr.length-1])
      document.body.appendChild(link)
      link.click()
    },
    //引用
    quote(item){
      this.iconShow = true
      this.replyData.quote = item.reply_person + '：' + '“ '+ item.content + ' ”'
      this.replyData.quote_reply_id = item.id
    },
    iconClick(){
      console.log('sdssaasad');
      this.replyData.quote = '';
      this.replyData.quote_reply_id = ''
      this.iconShow = false
    },
    //回复工单
    replyOrder(){
      var that = this
      that.dingPeopleNmae = that.dingPeopleNmae.map(item=>{
        return  item.replace('@','')
      })
      var params = {
        order_id:that.order_id,
        content:that.replyData.content,
        attach_image:that.imgList.join(','),
        attach_file:that.fileList2.join(','),
        quote_reply_id:that.replyData.quote_reply_id,
        at_person_name:that.dingPeopleNmae.join(','),
      }
      console.log(params,'params');
      orderReply(params)
      .then(res=>{
        console.log(res,'工单回复');
        if(res.message.status == 'success'){
          that.$message.success(res.message.text)
          that.getReTable()
          if(that.userid_list.length !== 0){ that.sendEvent() }
          that.iconShow = false
          that.replyData.quote == ''
          that.replyData.quote_reply_id = ''
          that.replyData.content = ''
          that.$refs.pictureUpload.uploadFiles = []
          that.fileList2 = []
          that.imgList = []
          that.dingPeople = []
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },

    

    //图片上传
    //移除图片
    imgHandleRemove(file) {
      console.log(file);
      var urlValue = file.response.data[0].url
      console.log('12123123');
      var that = this
      var params = {
        url:urlValue
      }
      removeAttach(params)
      .then(res=>{
          console.log(res,'删除附件');
          if(res.message.status == 'success'){
            that.$message.success('删除成功')
          let uploadFiles = that.$refs.pictureUpload.uploadFiles
          for (var i = 0; i < uploadFiles.length; i++) {
            if (uploadFiles[i]['url'] == file.url) {
              uploadFiles.splice(i, 1)
            }
          }
          that.imgList.forEach((item,index)=>{
            if(item == file.response.data[0].url){
              that.imgList.splice(index,1)
            }
          })
          }else{
            console.log(res.message.text);
          }
      })
      .catch(err=>{
        console.log(err,'删除附件');
      })
    },
    //上传图片限制
    beforeAvatarUpload(file){

        const isLt5M = file.size / 1024 / 1024 < 5;

        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        return  isLt5M;
    },
    imgRemove(file, fileList){
      console.log(file,'图片1');
      console.log(fileList,'图片2');
    },
    //放大图片
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    // 图片状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    imgHandleChange(file){
        // console.log(file,'asdasasd');
    },
    //图片上传成功的钩子
    imgSuccess(res, file, fileList){
        console.log(res,'res上传图片成功的返回');
        var that = this
        if(res.message.status == 'success'){
          that.imgList.push(res.data[0].url)
          that.$message.success('上传成功')
        }else{
          that.$message.error('上传失败')
          that.$refs.pictureUpload.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
        }
        console.log(that.imgList,'that.imgList');
    },


    //文件上传
    fileHandlePreview(file){
      console.log(file);
    },
    //文件限制
    beforeFileUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 7;
      // if(!isLt7M){
      //   this.$message.error('上传文件大小不能超过 7MB!')
      //   return isLt7M
      // }
    },
    fileHandleRemove(file, fileList){
      console.log(file,'删除文件');
      var that = this
      var urlValue = file.response.data[0].url
      var params = {
        url:urlValue
      }
      removeAttach(params)
      .then(res=>{
        console.log(res,'res删除文件');
        if(res.message.status == 'success'){
          that.$message.success('删除成功')
          that.fileList2.forEach((item,index)=>{
            if(item == file.response.data[0].url){
              that.fileList2.splice(index,1)
            }
          })
        }else{
          console.log(res.message.text);
        }
      })
      .catch(err=>{
        console.log(err);
      })

    },
    //删除之前
    fileBeforeRemove(file, fileList){
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //超出文件限制
    fileHandleExceed(files, fileList){
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    fileHandleChange(file){
      console.log(file,'文件');
    },
    fileSuccess(res, file, fileList){
      var that = this
      if(res.message.status == 'success'){
          that.fileList2.push(res.data[0].url)
      }else{
        that.$message.error(res.message.text)
        that.$refs.dmtUploadFile.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
      }
    },
    //问题已解决
    orderArchiving(){
      console.log("解决解决");
      var that = this
      var param = {
        order_id : that.order_id
      }
      orderClose(param)
      .then(res=>{
        console.log(res,'解决问题');
        if(res.message.status == 'success'){
          that.replyData.content = '问题已解决，等待归档'
          that.replyOrder()
          that.getDetail()
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },

    //完结工单
    orderCloseClick(){
      console.log("解决解决");
      var that = this
      var param = {
        order_id : that.order_id
      }
      orderFinish(param)
      .then(res=>{
        console.log(res,'解决问题');
        if(res.message.status == 'success'){
          that.closeShow = false
          that.getDetail()
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    archived(){
      this.$router.push({ name: 'phoneAddQuestion',params:{data:this.order_id,name:"归档问题"}})
      // this.$message.warning('当前页面暂不支持该功能，请前往“亿工单”进行归档操作')
    },
    //视频
    watchEvent(val){
      console.log(val,'val');
      this.videVisible = true
      this.videoSrc = val.url
      this.videoTitle = val.name
    },
    //选择企业内部的人
    ddEvent(){
      var  that  = this
      var configData = JSON.parse(localStorage.getItem('configData'));

      dd.ready(function(){
        dd.biz.contact.choose({
            multiple: true, //是否多选：true多选 false单选； 默认true
            users: [], //默认选中的用户列表，员工userid；成功回调中应包含该信息
            corpId: configData.corpId, //企业id
            max: 10, //人数限制，当multiple为true才生效，可选范围1-1500
            onSuccess: function(data) {
              console.log(data,'选择人');
              that.userid_list = []
              that.dingPeopleNmae = []
              that.dingPeople = data
              data.forEach(item=>{
                that.userid_list.push(item.emplId)
                item.name = '@' + item.name
                that.dingPeopleNmae.push(item.name)
              })
              console.log(that.replyData.content,'that.replyData.content');
              var reg = new RegExp("@","g")
              that.replyData.content = that.replyData.content.replace(reg,'')
            },
            onFail : function(err) {
              // that.$message.error(err)
              console.log(err,'选择企业内部的人');
              var reg = new RegExp("@","g")
              that.replyData.content = that.replyData.content.replace(reg,'')
            }
        });
      })
    },
    //@事件
    replyChange(value){
      console.log(value,'@');
      var str = value.charAt(value.length - 1)
      if(str == '@'){
        this.ddEvent()
      }
    },
    //删除dingPeople
    dagClose(val,index){
      console.log(index,'index');
      this.dingPeople.splice(index,1)
      this.dingPeopleNmae.splice(index,1)
      this.userid_list.splice(index,1)
      console.log(this.dingPeople,'this.dingPeople');
      console.log(this.dingPeopleNmae,'this.dingPeopleNmae');
      console.log( this.userid_list,' this.userid_list');
    },
    //发送钉钉消息
    sendEvent(){
      var that = this
      console.log(that.replyData,'that.replyData');
      that.dingPeopleNmae = that.dingPeopleNmae.map(item=>{
        return  item.replace('@','')
      })
      console.log(that.dingPeopleNmae,'that.dingPeopleNmae');

      var params = {
        order_id:that.order_id,
        reply_id:that.replyData.quote_reply_id,
        person_userid:that.userid_list.join(','),
        person_name:that.dingPeopleNmae.join(','),
        remark:that.replyData.content
      }
      sendMessage(params)
      .then(res=>{
        console.log(res,'发送消息的res');
        if(res.message.status == 'success'){
          that.dingPeople = []
          that.userid_list = []
          that.dingPeopleNmae = []
          that.replyData.content = []
          console.log('发送成功');
        }
      })
      .catch(err=>{
        that.$message.error(err)
      })
    },

    //设置工单状态为已读
    setReadedEvent(){
      var params = {
        order_id : this.order_id
      }
      setReaded(params)
      .then(res=>{
        if(res.message.status == 'success'){
            console.log(res,'设置工单状态');
        }else{
          this.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    async initWorker(){
      return this.worker = JSON.parse(localStorage.getItem('worker'))
    },
    //确认退回
    backClick(){
      var that = this
      if(that.backRemark == '') return that.$message.error('退回理由不能为空') 
      that.isBackShow = false
      var params = {
        order_id:that.order_id,
        remark:that.backRemark
      }
      orderBack(params)
      .then(res=>{
        console.log(res,'res');
        if(res.message.status == 'success'){
            that.backRemark = ''
            that.getDetail()
        }else{
          console.log(res.message.text);
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    //受理
    acceptOrder(){
      var that = this
      var params = {
        order_id: that.order_id
      }
      getOrderAccept(params)
        .then(res => {
          console.log(res, '受理');
          if (res.message.status == 'success') {
            that.$message.success(res.message.text)
            that.getDetail()
          } else {
            that.$message.error(res.message.text)
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //确认受理
    confirmAccept(){
      this.isAccepted = false
      this.acceptOrder()
    },
    // 打开图片窗口
    previewImageEvent(item,firstImgList){
      dd.biz.util.previewImage({
          urls: firstImgList,//图片地址列表
          current: item,//当前显示的图片链接，建议使用png、jpg格式图片
          onSuccess : function(res) {
            console.log(res,'res');
          },
          onFail : function(err) {
            console.log(err,'err');
          }
      })
    }

  },
  created() {},
  async mounted() {
    this.replyTable = []
    this.initWorker()
    var tempurl = window.location.hash
    console.log(tempurl,'tempurl');
    var jumpId = tempurl.split('?')[1].split('=')[1]
    console.log(jumpId,'kklkk')
    this.order_id = Number(jumpId)
    this.iconClick()
    await this.getDetail()
    this.setReadedEvent()
    this.getReTable()
  },
  activated(){
    this.replyTable = []
    this.initWorker()
    var tempurl = window.location.hash
    console.log(tempurl,'tempurl');
    var jumpId = tempurl.split('?')[1].split('=')[1]
    console.log(jumpId,'kklkk')
    this.order_id = Number(jumpId)
    this.iconClick()
    this.getDetail()
    this.setReadedEvent()
    this.getReTable()
  }
};
</script>
<style lang="scss" scoped>

textarea {
    white-space: pre-wrap; //保留所有空格
}


th{
  width: 150px;
}
.orderDetail{
    padding: 10px;
}
.my-label{
        background: #E1F3D8;
}

.reply{
  .el-textarea{
    height:100px;
    :deep(.el-textarea__inner){
        height: 100%;
        // border: none;
        resize: none;
        // background: #E9EEF3;
    }
}
.el-input{
  width: 50%;
    :deep(.el-input__inner){
      border: none;
      background: #e7e7e7;
      color: #666666;
    }
    i{
      font-size: 18px;
    }
}
.btn{
  text-align: right;
}

}

.replyTable{
    .content{
      .firstContent{
        width: 100%;
        border-bottom: 1px solid #d7d7d7;
        
        .firstname{
          color: #409eff;
          font-size: 14px;
        }
        .firstcontent{
          color: #333;
          margin-top: 15px;
          margin-bottom: 15px;
          font-size: 12px;
        }
        .filContent{
          display: flex;
          margin-bottom: 10px;
          overflow-x: scroll;
          .imag{
              .el-image{
                margin-left: 5px;
                cursor: pointer;
              }
          }
          .fileMain{
            display: flex;
            align-items: center;
            .fileList{
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              margin-left: 10px;

              .imageFile{
                width: 40px;
                // height: 40px;
              }
              .bootomName{
                width: 80px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                font-size: 12px;
                text-align: center;
              }
            }
          }
        }
      }
      .mainplaceon{
        // border-bottom: 1px solid #d7d7d7;
        .superTitle{
          color: #409eff;
          font-size: 14px;
        }
        .content{
          margin: 10px 0;
          font-size: 12px; 
        }
      }
      .mains{
        border-bottom: 1px solid #d7d7d7;
        margin: 5px 0;
        .title{
           display: flex;
           justify-content: space-between;
           font-size: 14px;
           .name{
            color: #409eff;
           }
           .time{
            color: #999;
           }
        }
        
        .atmain{
          margin-top: 5px;
          .atItem{
            color: #72bfec;
            margin-left: 3px;
            font-size: 12px;
          }
        }

        .reply_content{
          margin-top: 5px;
          // span{
          // background: rgb(221 221 221);
          // font-size: 12px;
          // }
          div{
            width: 50%;
          background: rgb(221 221 221);
          padding: 10px;
          font-size: 12px;
          line-height: 20px;
          color: #333;
          border-radius: 5px;
          }
        }
        .file{
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          .qs{
            width: 80%;
            font-size: 12px;
          }
          .impor{
            width: 20%;
            text-align: right;

            :deep(.el-button--text){
              font-size: 12px;
            }
          }
        }

        .fileMains{
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          overflow-x: scroll;

          .imgas{
            .el-image{
              width: 60px;
              height: 60px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
          .fileContents{
            display: flex;
            .fileListss{
              display: flex;
              flex-direction: column;
              align-items: center;
              font-size: 12px;
              margin-left: 10px;
              cursor: pointer;
              .fileTop{
                width: 40px;
              }
              .names{
                width: 80px;
                font-size: 12px;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
            }
          }
        }




      }
    }
  }

.tobeArchived{
   span{
    font-size: 16px;
  }
  .el-button{
    margin-left: 10px;
  }
}

:deep(.uploadImg){
  .el-upload--picture-card{
    width: 90px;
    height: 90px;
    line-height: 100px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width: 90px;
    height: 90px;
  }
}

::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
    }

    
</style>